import { dragHandlePluginDefaultKey, DragHandlePlugin } from '@tiptap/extension-drag-handle';
import Vue from 'vue';

const DragHandle = Vue.extend({
    name: 'DragHandleVue',
    props: {
        pluginKey: {
            type: [String, Object],
            default: dragHandlePluginDefaultKey,
        },
        editor: {
            type: Object,
            required: true,
        },
        tippyOptions: {
            type: Object,
            default: () => ({}),
        },
        onNodeChange: {
            type: Function,
            default: null,
        },
        class: {
            type: String,
            default: 'drag-handle',
        },
    },
    mounted() {
        const { editor, pluginKey, onNodeChange, tippyOptions, } = this.$props;
        editor.registerPlugin(DragHandlePlugin({
            editor,
            element: this.$el,
            pluginKey,
            tippyOptions,
            onNodeChange,
        }));
    },
    // eslint-disable-next-line vue/no-deprecated-destroyed-lifecycle
    beforeDestroy() {
        const { pluginKey, editor } = this.$props;
        editor.unregisterPlugin(pluginKey);
    },
    render(h) {
        return h('div', {
            class: this.class,
        }, this.$slots.default);
    },
});

export { DragHandle, DragHandle as default };
//# sourceMappingURL=index.js.map
